import React, { useState, useEffect, createContext } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Modal from '../../containers/modal';
import { useViewport } from '../../hooks/useViewport';
import './index.scss';
import { PrebookModalHeader } from './AvengersDoomsday';
import Loader from '../loader-spin';
import {
  redeemPrebook,
  togglePrebookModal
} from '../../burger-king-lib/redux/home/actions';
import useBKLocation from '../../hooks/useBKLocation';
import RestaurantOrderType from '../restaurant-order-type';
import { LocalSessionKey } from '../../burger-king-lib/constants/app-constants';
import YourProduct from './YourProduct';
import YourOrder from './YourOrder';
import { ROUTES } from '../../constants/app-constants';
import usePrebookInfo from '../../hooks/usePrebookInfo';
import DoomsdayProductList from './DoomsdayOffer';
import { RedeemContextProvider } from './Context';

const PreMealOrderStatusModal = ({ onClose }) => {
  const { isMobile } = useViewport();
  const [activeScreen, setActiveScreen] = useState('redeem');
  const [selectedItems, setSelectedItems] = useState([]);
  const { preBook } = usePrebookInfo();
  const { location } = useBKLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  const [orderType, setOrderType] = useState('restaurant');
  const handleClose = () => {
    if (typeof onClose === 'function') onClose();
  };

  const handleSetCartScreen = () => {
    setActiveScreen('cart');
  };

  const handleOrderTypeHandler = value => {
    setOrderType(value);
  };

  const theme = sessionStorage.getItem(LocalSessionKey.THEME);

  const handleSuccess = data => {
    const params = new URLSearchParams();
    params.set('type', 'pre-book');
    if (data?.order_id) {
      localStorage.setItem('WIN_ID', data?.order_id);
    }

    dispatch(togglePrebookModal());
    history.push({
      pathname: ROUTES.ORDER_STATUS,
      search: params.toString()
    });
  };

  const handleNavigateToTermsAndConditions = () => {
    dispatch(togglePrebookModal());

    if (isMobile) {
      history.push(ROUTES.TERMS_AND_CONDITIONS);
      return;
    }
    history.push(ROUTES.TERMS);
  };

  const handleRedeemPick = data => {
    setSelectedItems(prev => {
      const prebookCode = data?.prebook_code;
      if (prev.includes(prebookCode)) {
        return [...prev.filter(item => item !== prebookCode)];
      }

      return [...prev, prebookCode];
    });
  };

  const handleRedeem = () => {
    const payload = {
      outlet_id: sessionStorage.getItem(LocalSessionKey.OUTLET_ID),
      prebook_codes: selectedItems
    };
    dispatch(redeemPrebook(payload, { success: handleSuccess }));
  };

  const renderContent = () => {
    const status = preBook?.status;

    if (status === 'RESERVED' && preBook?.isPrebookingOpened) {
      return (
        <div className="pre-book-status-model__outer-wrapper">
          <YourProduct>
            {/* <YourProduct.ImageCard
              status={status}
              description={preBook?.productName}
              heading="Your meal is reserved"
              isCountDownVisible={!preBook?.isRedeemStarted}
              unLocksAt={preBook?.unLocksAt}
            />
            <YourProduct.BookingInfoCard
              amount={preBook?.totalAmount}
              preBookID={preBook?.mainPreBookID}
              mobileNumber={preBook?.mobileNumber}
              redeemUntil={preBook?.redeemUntil}
              unLocksAt={preBook.unLocksAt}
            /> */}
            <DoomsdayProductList
              onRedeem={handleRedeemPick}
              products={preBook?.products || []}
              redeemUntil={preBook?.redeemUntil}
            />
            <YourProduct.TermsButton
              onClick={handleNavigateToTermsAndConditions}
            />
          </YourProduct>
        </div>
      );
    }

    if (
      status === 'RESERVED' &&
      !preBook?.isPrebookingOpened &&
      activeScreen === 'redeem'
    ) {
      return (
        <div className="pre-book-status-model__outer-wrapper">
          <YourProduct>
            <DoomsdayProductList
              onRedeem={handleRedeemPick}
              products={preBook?.products || []}
              redeemUntil={preBook?.redeemUntil}
            />
            <div className="pre-book-status-model__horizontal-space ">
              <YourProduct.TermsButton
                onClick={handleNavigateToTermsAndConditions}
              />
            </div>
            <YourProduct.LocationCard
              className="pre-book-status-model__location"
              location={location}
            />
            <YourProduct.RedeemButton
              onClick={handleSetCartScreen}
              disabled={selectedItems.length === 0}
            />
          </YourProduct>
        </div>
      );
    }

    if (
      status === 'RESERVED' &&
      !preBook?.isPrebookingOpened &&
      activeScreen === 'cart'
    ) {
      return (
        <YourOrder>
          <YourOrder.Wrapper>
            <>
              <YourOrder.Info>WHAT IS YOUR ORDER TYPE</YourOrder.Info>
              <RestaurantOrderType
                type={orderType}
                onChange={handleOrderTypeHandler}
                leftValue="restaurant"
                rightValue="takeaway"
                theme={theme}
              />
              <YourOrder.Description />
              <YourOrder.DescriptionTwo />
              <YourProduct.LocationCard location={location} />
            </>
          </YourOrder.Wrapper>
          <YourOrder.Footer onClick={handleRedeem}>
            Checkout - ₹0.00
          </YourOrder.Footer>
        </YourOrder>
      );
    }

    if (status === 'REDEEMED') {
      return (
        <YourOrder>
          <YourOrder.Wrapper>
            <>
              <YourOrder.Info>WHAT IS YOUR ORDER TYPE</YourOrder.Info>
              <RestaurantOrderType
                type={orderType}
                onChange={handleOrderTypeHandler}
                leftValue="restaurant"
                rightValue="takeaway"
                theme={theme}
              />
              <YourOrder.Description />
              <YourOrder.DescriptionTwo />
              <YourProduct.LocationCard location={location} />
            </>
          </YourOrder.Wrapper>
        </YourOrder>
      );
    }

    if (status === 'EXPIRED') {
      return (
        <div className="pre-book-status-model__outer-wrapper">
          <YourProduct>
            {/* <YourProduct.ImageCard
              status={status}
              description={preBook?.productName}
              heading="Redemption window ended"
              isCountDownVisible={preBook?.isPrebookingOpened}
              unLocksAt={preBook?.unLocksAt}
            />
            <YourProduct.BookingInfoCard
              amount={preBook?.amount}
              preBookID={preBook?.preBookID}
              mobileNumber={preBook?.mobileNumber}
              redeemUntil={preBook?.redeemUntil}
              unLocksAt={preBook.unLocksAt}
            /> */}
            <DoomsdayProductList
              onRedeem={handleRedeemPick}
              products={preBook?.products || []}
              redeemUntil={preBook?.redeemUntil}
            />
            <YourProduct.TermsButton
              onClick={handleNavigateToTermsAndConditions}
            />
          </YourProduct>
        </div>
      );
    }

    if (status === 'PENDING_PAYMENT') {
      return (
        <div className="pre-book-status-model__outer-wrapper">
          <YourProduct>
            <YourProduct.ImageCard
              status="PAYMENT PENDING"
              description={preBook?.productName}
              heading="Payment Confirmation Pending"
              isCountDownVisible={!preBook?.isPrebookingOpened}
              unLocksAt={preBook?.unLocksAt}
            />

            <YourProduct.TermsButton
              onClick={handleNavigateToTermsAndConditions}
            />
          </YourProduct>
        </div>
      );
    }

    return (
      <div className="pre-book-status-model__outer-wrapper">
        <Loader />
      </div>
    );
  };

  const getHeaderTitle = () => {
    const status = preBook?.status;

    if (
      (status === 'RESERVED' && activeScreen === 'cart') ||
      status === 'REDEEMED'
    )
      return 'Your order';

    return 'Your pre-booking';
  };

  return (
    <Modal
      isMobileFullLayout={isMobile}
      hideClose
      customClass="pre-book-status-model__custom-class"
      modalCustomClass="pre-book-status-model"
      contentCustomClass="pre-book-status-model__modal-wrapper"
      onCloseHandler={handleClose}
      width="375px"
    >
      <RedeemContextProvider
        selectedItems={selectedItems}
        status={preBook?.status}
      >
        <PrebookModalHeader title={getHeaderTitle()} onGoBack={handleClose} />
        {renderContent()}
      </RedeemContextProvider>
    </Modal>
  );
};

export default PreMealOrderStatusModal;
